import type { AdminUiLabelsInput } from './i18n'
import { adminUiEn } from './i18n-messages'

export type AdminUiMessageKey = keyof typeof adminUiEn

/** Builds the labels for <AdminUiProvider> from an app's translate function (its catalog includes adminUiEn / adminUiId). */
export function buildAdminUiLabels(t: (key: AdminUiMessageKey) => string, numberLocale: string): AdminUiLabelsInput {
  return {
      close: t('adminui.close'),
      confirm: t('adminui.confirm'),
      cancel: t('adminui.cancel'),
      unsavedChangesRegion: t('adminui.unsavedChangesRegion'),
      unsavedChanges: t('adminui.unsavedChanges'),
      discard: t('adminui.discard'),
      saveChanges: t('adminui.saveChanges'),
      saving: t('adminui.saving'),
      breadcrumb: t('adminui.breadcrumb'),
      tableLoadError: t('adminui.tableLoadError'),
      tableReload: t('adminui.tableReload'),
      select: t('adminui.select'),
      searchPlaceholder: t('adminui.searchPlaceholder'),
      noResults: t('adminui.noResults'),
      chooseFile: t('adminui.chooseFile'),
      numberLocale,
      imageCrop: {
        title: t('adminui.crop.title'),
        hint: t('adminui.crop.hint'),
        zoom: t('adminui.crop.zoom'),
        confirm: t('adminui.crop.confirm'),
        saving: t('adminui.crop.saving'),
        cancel: t('adminui.crop.cancel'),
        failed: t('adminui.crop.failed'),
      },
      richText: {
        label: t('adminui.rte.label'),
        toolbarLabel: t('adminui.rte.toolbarLabel'),
        paragraph: t('adminui.rte.paragraph'),
        heading2: t('adminui.rte.heading2'),
        heading3: t('adminui.rte.heading3'),
        bold: t('adminui.rte.bold'),
        italic: t('adminui.rte.italic'),
        underline: t('adminui.rte.underline'),
        strike: t('adminui.rte.strike'),
        orderedList: t('adminui.rte.orderedList'),
        bulletList: t('adminui.rte.bulletList'),
        blockquote: t('adminui.rte.blockquote'),
        horizontalRule: t('adminui.rte.horizontalRule'),
        link: t('adminui.rte.link'),
        linkPrompt: t('adminui.rte.linkPrompt'),
        image: t('adminui.rte.image'),
        table: t('adminui.rte.table'),
        addRow: t('adminui.rte.addRow'),
        addColumn: t('adminui.rte.addColumn'),
        deleteTable: t('adminui.rte.deleteTable'),
        undo: t('adminui.rte.undo'),
        redo: t('adminui.rte.redo'),
        help: t('adminui.rte.help'),
      },
    }
}
